import { sb } from "./sb.ts";

export interface Brand { company_name: string; app_name: string; logo_path: string | null; color_primary: string; color_accent: string; setup_done: boolean }
export const DEFAULT_BRAND: Brand = { company_name: "", app_name: "Messaging", logo_path: null, color_primary: "#1f6feb", color_accent: "#25d366", setup_done: false };

export async function loadBrand(): Promise<Brand> {
  const { data } = await sb.rpc("public_brand");
  return { ...DEFAULT_BRAND, ...(data ?? {}) };
}
export const logoUrl = (path: string | null) => path ? sb.storage.from("brand").getPublicUrl(path).data.publicUrl : null;

/** the company's colours, name and icon on the page (each company's project carries its own brand) */
export function applyBrand(b: Brand) {
  const r = document.documentElement.style;
  r.setProperty("--primary", b.color_primary);
  r.setProperty("--accent", b.color_accent);
  document.title = b.app_name || b.company_name || "Messaging";
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", b.color_primary);
  const logo = logoUrl(b.logo_path);
  if (logo) for (const sel of ['link[rel="icon"]', 'link[rel="apple-touch-icon"]']) document.querySelector(sel)?.setAttribute("href", logo);
}
